<template>
	<div class="flex justify-start w-full md:w-auto md:flex gap-4 items-center flex-wrap">
		<span class="hidden lg:block font-header uppercase text-md text-sand w-full md:w-auto leading-none">{{ props.label }}</span>
		<div class="flex flex-wrap gap-4">
			<a
					v-for="option in options"
					:key="option.key"
					href="#"
					@click.prevent="toggleOption(option.key)"
					:class="{ 'bg-ivory text-black! inset-ring-ivory': modelValue.includes(option.key) }"
					class="button text-ivory relative justify-center hover:bg-ivory hover:text-black! hover:inset-ring-ivory!"
				>
				<span v-html="option.label"></span>
			</a>
		</div>
	</div>
	
</template>

<script setup>

const props = defineProps({
	modelValue: {
		type: Array,
		default: () => [],
	},
	options: {
		type: Array,
		required: true,
	},
	label: {
		type: String,
		default: "Filter",
	},
});

const emit = defineEmits(["update:modelValue"]);

function toggleOption(optionId) {
	const current = [...props.modelValue];
	const index = current.indexOf(optionId);

	if (index > -1) {
		current.splice(index, 1);
	} else {
		current.push(optionId);
	}

	emit("update:modelValue", current);
}
</script>
